export default {
    name: "DigiByte",
    nameAux: "Dogecoin",
    coin: "DGB",
    coinAux: "DOGE",
    scheme: "SOLO",
    account: 'DGnECApfz1dinH6w6kDUdKFGqH3AzUMvTi',
    accountAux: 'DPBLUvfyHaBb6VUw1xFYTkQZ79FknTXwKn',
    url: '',
    explorer_url: '',
    explorer: {
        address: "https://digiexplorer.info/address/",
        height: "https://digiexplorer.info/block/",
        hash: "https://digiexplorer.info/block/",
        tx: "https://digiexplorer.info/tx/",
    },
    explorerAux: {
        address: 'https://dogechain.info/address/',
        height: 'https://dogechain.info/block/',
        hash: 'https://dogechain.info/block/',
        tx: 'https://dogechain.info/tx/',
    },
    ports: [
        {
            info: 'LOW',
            host: 'molepool.com',
            port: 4601,
            diff: 65536,
        },
        {
            info: 'MID',
            host: 'molepool.com',
            port: 4602,
            diff: 1048576,
        },
        {
            info: 'HIGH',
            host: 'molepool.com',
            port: 4603,
            diff: 10027008,
        },
    ]
};
